import React, { Component } from "react";
import { addTab } from "../../store/broadcaster/BroadcastRegister";
import { Tabs } from "antd";
import TicketTable from "./TicketTable";
import CreateTicket from "./CreateTicket/CreateTicket";
import TicketDetailTab from "./TikcetDetailsTab"

const { TabPane } = Tabs;
const fromWhere = "Ticket Management";
var status = 0;


export default class TicketManagement extends Component {
  subscribe;
  constructor(props) {
    super(props);
    this.newTabIndex = 0;
    const panes = [
      {
        title: "Ticket Management",
        content: <TicketTable activeKey={this.props.activeKey}  getDetails={this.getDetails}/>,
        key: "1",
        closable: false,
      },
    ];
    this.state = {
      activeKey: panes[0].key,
      removeActiveKey: "",
      panes,
    };
    this.subscribe = addTab.subscribe((tabInfo) => {
      if (tabInfo === null) return;
      else this.add(tabInfo);
    });
  }

  onChange = (activeKey) => {
    this.setState({ activeKey });
  };

  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };

  getDetails = (tabDetails) => {
    this.add(tabDetails);
};

 add = (tabDetails) => {
    let { panes } = this.state;
    let activeKey = `newTab${this.newTabIndex++}`;
    status = activeKey
    this.state.removeActiveKey = activeKey;
    switch(tabDetails.type) {  
      case 'Create Ticket' :
        panes.push({ title: "Create Ticket",
         content: <CreateTicket activeKey={this.state.removeActiveKey}
         remove={this.remove} fromWhere={fromWhere}/>, 
         key: activeKey }); 
        break    
        case "ticket-details" :
          panes.push({ title: `Ticket ID:${tabDetails.item.TicketID}`,
         content: <TicketDetailTab remove={this.remove} activeKey={this.state.removeActiveKey} TicketInfo={tabDetails.item} fromWhere={fromWhere}/>, 
         key: activeKey }); 
         console.log(tabDetails)
         break
      default:
        console.error("wrong page info");
    }
    this.setState({ panes, activeKey });
  };


  remove = (targetKey) => {
    console.log("innn")
    const { panes, activeKey } = this.state;
    let newActiveKey = activeKey;
    let lastIndex;
    panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const newPanes = panes.filter((pane) => pane.key !== targetKey);
    if (newPanes.length && newActiveKey === targetKey) {
      if (lastIndex >= 0) {
        newActiveKey = newPanes[lastIndex].key;
      } else {
        newActiveKey = newPanes[0].key;
      }
    }
    this.setState({
      panes: newPanes,
      activeKey: newActiveKey,
    });
  };

  render() {
    return (
      <Tabs
        onChange={this.onChange}
        activeKey={this.state.activeKey}
        type="editable-card"
        onEdit={this.onEdit}
      >
        {this.state.panes.map((pane) => (
          <TabPane tab={pane.title} key={pane.key} closable={pane.closable}>
            {pane.content}
          </TabPane>
        ))}
      </Tabs>
    );
  }
}
